import { formatDate } from '../../utils/formatDate';
import { FileText } from 'lucide-react';

export default function ImportProgress({ logs }) {
  if (!logs || logs.length === 0) return null;

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-5">
      <h3 className="font-semibold text-gray-800 mb-4">Import History</h3>
      <div className="overflow-x-auto">
        <table className="min-w-[600px] w-full text-sm">
          <thead>
            <tr className="border-b border-gray-200">
              <th className="text-left py-2 px-3 text-gray-500 font-medium">File</th>
              <th className="text-left py-2 px-3 text-gray-500 font-medium">Type</th>
              <th className="text-right py-2 px-3 text-gray-500 font-medium">Total</th>
              <th className="text-right py-2 px-3 text-gray-500 font-medium">Success</th>
              <th className="text-right py-2 px-3 text-gray-500 font-medium">Failed</th>
              <th className="text-left py-2 px-3 text-gray-500 font-medium">By</th>
              <th className="text-left py-2 px-3 text-gray-500 font-medium">Date</th>
            </tr>
          </thead>
          <tbody>
            {logs.map(log => (
              <tr key={log.id} className="border-b border-gray-100">
                <td className="py-2 px-3 flex items-center gap-2">
                  <FileText className="w-4 h-4 text-gray-400" />
                  <span className="truncate max-w-[200px]">{log.file_name}</span>
                </td>
                <td className="py-2 px-3 uppercase text-xs">{log.file_type}</td>
                <td className="text-right py-2 px-3">{log.total_count}</td>
                <td className="text-right py-2 px-3 text-green-600">{log.success_count}</td>
                <td className="text-right py-2 px-3 text-red-600">{log.fail_count}</td>
                <td className="py-2 px-3 text-gray-600">{log.imported_by}</td>
                <td className="py-2 px-3 text-gray-500 text-xs">{formatDate(log.imported_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
